var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "#1ABD17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9253 39.7C25.7337 41.6167 26.5003 43.3417 27.6503 44.6833L33.7837 50.8167C34.9337 51.9667 36.467 52.7333 38.192 52.7333C39.917 52.7333 41.4503 52.1583 42.6003 50.8167L54.867 38.55C56.017 37.4 56.7837 35.8667 56.7837 34.1417C56.7837 32.4167 56.2087 30.8833 54.867 29.7333L48.7337 23.6C47.392 22.2583 45.667 21.6833 43.7503 21.875C42.217 22.0667 40.8753 22.6417 39.917 23.6L27.842 35.8667C26.692 36.825 26.117 38.3583 25.9253 39.7ZM41.642 27.4333L40.6837 35.1C40.492 36.0583 39.917 36.6333 38.9587 36.825L31.292 37.7833L41.642 27.4333ZM39.5337 40.4667C42.217 40.0833 44.3253 38.1667 44.517 35.4833L45.667 26.0917C45.8587 26.0917 45.8587 26.2833 46.0503 26.2833L52.1837 32.4167C53.142 33.375 53.142 34.9083 52.1837 35.8667L39.917 48.1333C38.9587 49.0917 37.4253 49.0917 36.467 48.1333L30.5253 42C30.3337 41.8083 30.3337 41.6167 30.142 41.6167L39.5337 40.4667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7502 55.4167C21.3252 55.4167 21.7085 55.225 22.0918 54.8417L27.8418 49.0917C28.6085 48.325 28.6085 47.175 27.8418 46.4083C27.0752 45.6417 25.9252 45.6417 25.1585 46.4083L19.4085 52.1583C18.6418 52.925 18.6418 54.075 19.4085 54.8417C19.7918 55.225 20.1752 55.4167 20.7502 55.4167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7583 56.7583L31.675 54.8417C32.4417 54.075 32.4417 52.925 31.675 52.1583C30.9083 51.3917 29.7583 51.3917 28.9917 52.1583L27.075 54.075C26.3083 54.8417 26.3083 55.9917 27.075 56.7583C27.4583 57.1417 27.8417 57.3333 28.4167 57.3333C28.9917 57.3333 29.375 57.1417 29.7583 56.7583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendInvitation);
export default __webpack_public_path__ + "static/media/sendInvitation.6e7e66b9913b3a35a993d8673a5d8012.svg";
export { ForwardRef as ReactComponent };